import { render, staticRenderFns } from "./SearchHelpModal.vue?vue&type=template&id=912ce716"
import script from "./SearchHelpModal.vue?vue&type=script&lang=ts"
export * from "./SearchHelpModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports